import { useNavigate, useSearchParams } from "react-router-dom";
import FailSnackbar from "../../components/ui/snackbar/fail.component";
import { postPurchaseConfirm } from "../../lib/apis/v1/purchase.service";
import { useMutation } from "@tanstack/react-query";
import type { PurchaseConfirmResponse } from "../../lib/apis/dtos/request/purchase.request";
import { useEffect } from "react";

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const paymentKey = searchParams.get("paymentKey");
  const orderId = searchParams.get("orderId");
  const amount = searchParams.get("amount");
  const pathname = searchParams.get("pathname");
  const navigate = useNavigate();

  const purchaseConfirmMutation = useMutation({
    mutationFn: (request: PurchaseConfirmResponse) => postPurchaseConfirm(request),
    onSuccess: (res) => {
      const { error, message } = res;
      if (error) {
        FailSnackbar(`결제 실패 사유(${message})`)
      } else {
        navigate(pathname || "/", { replace: true })
      }
    }
  })

  useEffect(() => {
    if (paymentKey && orderId && amount) {
      purchaseConfirmMutation.mutate({
        paymentKey,
        orderId,
        amount,
      })
    }
  }, [paymentKey, orderId, amount])

  return (
    <div>
      success
      <p>{paymentKey}</p>
      <p>{orderId}</p>
      <p>{amount}</p>
    </div>

  );
}